export enum NotificationTemplates {
  WishList = 'wishlist',
  Compare = 'compare',
  ReviewsError = 'reviewsError',
  OnlineOrderError = 'onlineOrderError',
  CopySKU = 'copySKU',
  ReviewFormError = 'reviewFormError',
}
